import { OWNER_TYPES } from "@/static/ownerTypes";
import { Expose } from "class-transformer";
import { IsBoolean, IsEnum, IsNumber, IsString } from "class-validator";

export class Owner {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  userId!: string;
  @IsEnum(OWNER_TYPES)
  @Expose()
  type!: OWNER_TYPES;
  @IsString()
  @Expose()
  name!: string;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
}
